module.exports = __webpack_public_path__ + "img/ra.f0d25a99.jpg";